var map = {
	"./component/building-manager/building-manager.routing": [
		"./src/app/component/building-manager/building-manager.routing.ts",
		"default~component-building-manager-building-manager-routing~component-resident-resident-routing",
		"component-building-manager-building-manager-routing"
	],
	"./component/resident/resident.routing": [
		"./src/app/component/resident/resident.routing.ts",
		"default~component-building-manager-building-manager-routing~component-resident-resident-routing",
		"component-resident-resident-routing"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;